<template>
  <div class="product-engraving-heading">
    <h3 class="product-engraving-heading__title">
      {{ title }}
      <span v-if="isActive">
        (+<ShopifyPrice
          class="product-engraving-heading__price"
          v-if="variant"
          :amount="parseFloat(variant.price.amount)"
        />)
      </span>
    </h3>
    <div class="product-engraving-heading__toggle">
      <button
        class="product-engraving-heading__button"
        :class="{
          'product-engraving-heading__button--active': !isActive,
        }"
        @click.prevent="emits('setIsActive', false)"
      >
        None
      </button>
      <span class="product-engraving-heading__divider">/</span>
      <button
        type="button"
        class="product-engraving-heading__button"
        :class="{
          'product-engraving-heading__button--active': isActive,
        }"
        @click.prevent="emits('setIsActive', true)"
      >
        Select
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { VariantFieldsFragment } from '_library'
import ShopifyPrice from '../../shopify/ShopifyPrice.vue'

defineProps<{
  title: string
  isActive: boolean
  variant: VariantFieldsFragment
}>()

const emits = defineEmits(['setIsActive'])
</script>

<style lang="scss" scoped>
@import '~styles/base';

.product-engraving-heading {
  --input-spacing-y: 10px;
  align-items: baseline;
  line-height: 1;

  &__title {
    @include type-xs-uppercase;
    margin-bottom: 10px;
    padding-right: 5px;
  }

  &__toggle {
    flex-wrap: wrap;
    display: flex;
  }

  @include breakpoint('xl') {
    flex-direction: column;
  }

  &__button {
    position: relative;
    cursor: pointer;
    color: var(--color-muted);
    line-height: 1;
    @include underline;
  }

  &__divider {
    color: var(--color-muted);
    margin: 0 0.5ch;
  }

  &__hidden {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  @include breakpoint('l') {
    &__title {
      margin-bottom: var(--input-spacing-y);
    }

    &__divider {
      display: none;
    }

    &__toggle {
      display: grid;
      grid-auto-flow: column;
      justify-content: flex-start;
      grid-gap: var(--product-button-gap);
    }

    &__button {
      @include button-outline;
      min-width: 8px;
      height: auto;
      padding: 8px 8px 8px;

      color: var(--color-muted);
      border-color: var(--color-light);
      text-transform: none;

      &--active {
        color: var(--color-dark);
        border-color: var(--color-dark);
      }
    }
  }
}
</style>
